const menuContainer = document.querySelector(
  ".collection-tabs-list "
);
let isDown = !1,
  startX,
  scrollLeft;
menuContainer.addEventListener("mousedown", (e) => {
  (isDown = !0),
    menuContainer.classList.add("active"),
    (startX = e.pageX - menuContainer.offsetLeft),
    (scrollLeft = menuContainer.scrollLeft);
}),
  menuContainer.addEventListener("mouseleave", () => {
    (isDown = !1), menuContainer.classList.remove("active");
  }),
  menuContainer.addEventListener("mouseup", () => {
    (isDown = !1), menuContainer.classList.remove("active");
  }),
  menuContainer.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const walk = (e.pageX - menuContainer.offsetLeft - startX) * 3;
    menuContainer.scrollLeft = scrollLeft - walk;
  }),
  menuContainer.addEventListener("touchstart", (e) => {
    (isDown = !0),
      menuContainer.classList.add("active"),
      (startX = e.touches[0].pageX - menuContainer.offsetLeft),
      (scrollLeft = menuContainer.scrollLeft);
  }),
  menuContainer.addEventListener("touchend", () => {
    (isDown = !1), menuContainer.classList.remove("active");
  }),
  menuContainer.addEventListener("touchmove", (e) => {
    if (!isDown) return;
    const walk = (e.touches[0].pageX - menuContainer.offsetLeft - startX) * 3;
    menuContainer.scrollLeft = scrollLeft - walk;
  });
